import { useEffect, useState } from "react";
import { Link, useLocation } from "wouter";
import {
  analyticsAllowed,
  isPlayerKioskPath,
  readConsent,
  writeConsent,
} from "@workspace/observability";
import {
  initAnalyticsIfConsented,
  shutdownAnalytics,
} from "@workspace/observability/web";
import { t } from "@workspace/strings/web";

import { Button } from "@/components/ui/button";

export function CookieConsentBanner() {
  const [location] = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isPlayerKioskPath(location)) {
      setVisible(false);
      return;
    }
    setVisible(readConsent() === null);
  }, [location]);

  if (!visible) return null;

  const acceptAll = () => {
    writeConsent("all");
    void initAnalyticsIfConsented();
    setVisible(false);
  };

  const rejectNonEssential = () => {
    writeConsent("necessary");
    shutdownAnalytics();
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label={t("consent.dialog.ariaLabel")}
      className="fixed inset-x-0 bottom-0 z-[100] border-t border-border bg-background/95 p-4 shadow-lg backdrop-blur supports-[backdrop-filter]:bg-background/80"
    >
      <div className="container mx-auto flex max-w-4xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-muted-foreground">
          {t("consent.banner.message")}{" "}
          <Link href="/privacy" className="text-primary underline">
            {t("consent.banner.privacyLink")}
          </Link>{" "}
          {t("consent.banner.and")}{" "}
          <Link href="/cookies" className="text-primary underline">
            {t("consent.banner.cookiesLink")}
          </Link>
          .
        </p>
        <div className="flex shrink-0 flex-wrap gap-2">
          <Button variant="outline" size="sm" onClick={rejectNonEssential}>
            {t("consent.actions.rejectNonEssential")}
          </Button>
          <Button size="sm" onClick={acceptAll}>
            {t("consent.actions.acceptAll")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export function hasAnalyticsConsent(): boolean {
  return analyticsAllowed();
}
